import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { ExZoneType } from "@domain/project/floorplan/zones/ex-zone";
import { FloorplanZonesService } from "@project/floorplan-zones.service";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-ex-zone-menu",
  templateUrl: "./floorplan-ex-zone-menu.component.html",
  styleUrls: ["./floorplan-ex-zone-menu.component.scss"],
  imports: [
    UiKitModule,
    FloorplanMenuItemButtonsComponent,
    ToggleVisibilityButtonComponent,
    ToggleLockButtonComponent,
    ToggleItemTextVisibilityButtonComponent,
  ],
})
export class FloorplanExZoneMenuComponent {
  private floorplanService = inject(FloorplanService);
  private floorplanZonesService = inject(FloorplanZonesService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;
  protected readonly ExZoneType = ExZoneType;
  protected readonly tooltipTextAddExZone = (type: number) =>
    $localize`:@@floorplan.button.addExZone:Ex-Zone ${type}:exZoneType: platzieren`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  protected addExZone(zoneType: ExZoneType) {
    this.floorplanZonesService.addExZone(zoneType);
  }

  protected dragExZone(zoneType: ExZoneType) {
    this.dragDropService.setDragged({ type: DraggedItemType.EX_ZONE, config: zoneType });
  }

  protected updateExZonesItemTextVisibility(visible: boolean) {
    this.floorplanState.updateExZonesItemTextVisibility(visible);
  }
}
